import React from 'react';
import { Form, FormCardGroup, FormCheckBox, FormWrapper } from '../Helpers/Form';
import './Messages.css';
import DayOfWeek from '../Helpers/Storage/DayOfWeek.json';
import Storage from '../Helpers/Storage/Storage';

const dayOfWeek = new Map(DayOfWeek);

const PateEntryRequest = props => {
  const {
    pets2Pate, from, selectedDayOfWeek, acceptPateEntry, id, accepted, petsMap, to,
    uid, fromUid
  } = props;
  return (
    <div className="pateEntry">
      <Form onChange={() => { /* let event bubble */ }} onSubmit={() => acceptPateEntry(id)} >
        <p>Möchtest du ab dem {from} {to && (`bis ${to}`)} meine Tiere hüten?</p>
        <FormCardGroup type="card">
          {
            pets2Pate && petsMap && pets2Pate.map((petId, index) => {
              const pet = petsMap.get(petId);
              if (pet) {
                return (
                  <FormCheckBox
                    name="pets2Pate"
                    text={pet.name}
                    key={petId}
                    value={index}
                    checked={false}
                    image={pet.image || Storage.get(pet.species)}
                  />);
              }
              return null;
            })
          }
        </FormCardGroup>

        {selectedDayOfWeek &&
        <FormCardGroup type="card" text="Wöchentlich, jeden" >
          {selectedDayOfWeek.map(key => (
            <FormCheckBox
              name="selectedDayOfWeek"
              text={dayOfWeek.get(`${key}`)}
              key={key}
              checked={false}
            />))}
        </FormCardGroup>}

        { accepted && 'Akzeptiert'}
        {uid === fromUid && !accepted && 'Ausstehend'}
        {uid !== fromUid && !accepted && (<FormWrapper><button className="button" >Akzeptieren</button></FormWrapper>)}
      </Form>
    </div>);
};

export default PateEntryRequest;



// WEBPACK FOOTER //
// ./src/pages/Messages/PateEntryRequest.js